import CBBA1010RequestModel from '@/api/data/CBB/CBBA1010/CBBA1010RequestModel'
import CBBA1010ResponseModel from '@/api/data/CBB/CBBA1010/CBBA1010ResponseModel'

import ApiUrlConstants from '@/common/ApiUrlConstants'
import RestService from '@/common/RestService'

export default class CBBG1010Service {
  /**
   * CBBA1010 API
   * @returns Response CBBA1010
   */
  public async callAPICBBA1010(): Promise<CBBA1010ResponseModel> {
    const cbba1010RequestModel = new CBBA1010RequestModel()
    const cbba1010ResponseModel: CBBA1010ResponseModel = <
      CBBA1010ResponseModel
    > await RestService.post(ApiUrlConstants.CBBA1010, cbba1010RequestModel)

    return cbba1010ResponseModel
  }
}
